export const numerify = (text: string) => {
  return text.split('').join(' ');
};
